<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { api, jsonBody } from '../../services/api'

interface ReportRow {
  report: {
    id: string
    bottleId: string
    commentId: string | null
    type: string
    message: string | null
    createdAt: string
    resolvedAt: string | null
  }
  bottleName: string
}
const items = ref<ReportRow[]>([])
const status = ref('open')
const error = ref('')
async function load() {
  try {
    const data = await api<{ items: ReportRow[] }>(`/admin/reports?status=${status.value}`)
    items.value = data.items
  } catch (caught) {
    error.value = caught instanceof Error ? caught.message : 'Reports could not be loaded.'
  }
}
async function toggle(item: ReportRow) {
  await api(`/admin/reports/${item.report.id}`, {
    method: 'PATCH',
    ...jsonBody({ resolved: !item.report.resolvedAt }),
  })
  await load()
}
onMounted(load)
</script>

<template>
  <header class="admin-heading">
    <div>
      <p class="eyebrow">Safety and accuracy</p>
      <h1>Reports</h1>
      <p>Resolve problems raised by anyone who encounters a bottle.</p>
    </div>
    <select v-model="status" @change="load">
      <option value="open">Open reports</option>
      <option value="resolved">Resolved reports</option>
    </select>
  </header>
  <p v-if="error" class="form-error banner">{{ error }}</p>
  <section class="report-list">
    <article v-for="item in items" :key="item.report.id" class="admin-card report-row">
      <div class="report-icon">!</div>
      <div>
        <header>
          <span class="status-pill warning">{{ item.report.type.replaceAll('_', ' ') }}</span
          ><time>{{ new Date(item.report.createdAt).toLocaleString() }}</time>
        </header>
        <h2>
          <RouterLink :to="`/admin/bottles/${item.report.bottleId}`">{{
            item.bottleName
          }}</RouterLink>
        </h2>
        <p>{{ item.report.message || 'No additional details supplied.' }}</p>
        <button class="button secondary" @click="toggle(item)">
          {{ item.report.resolvedAt ? 'Reopen report' : 'Mark resolved' }}
        </button>
      </div>
    </article>
    <p v-if="!items.length" class="empty-copy">No {{ status }} reports.</p>
  </section>
</template>
